import * as types from './constants';

export const login = (login, password) => ({
    types: [
        types.LOGIN_ATTEMPT_REQUEST,
        types.LOGIN_ATTEMPT_SUCCESS,
        types.LOGIN_ATTEMPT_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/auth/login`,
            method: 'POST',
            body: {
                login,
                password,
            }
        }),
});

export const registerUser = (form) => ({
    types: [
        types.USER_REGISTRATION_REQUEST,
        types.USER_REGISTRATION_SUCCESS,
        types.USER_REGISTRATION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/auth/register`,
            method: 'POST',
            body: form
        }),
});

export const sendPasswordResetEmail = (data) => ({
    types: [
        types.USER_FORGOT_PASSWORD_REQUEST,
        types.USER_FORGOT_PASSWORD_SUCCESS,
        types.USER_FORGOT_PASSWORD_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/auth/password/email`,
            method: 'POST',
            body: data
        }),
});

export const resetPassword = (data) => ({
    types: [
        types.USER_RESET_PASSWORD_REQUEST,
        types.USER_RESET_PASSWORD_SUCCESS,
        types.USER_RESET_PASSWORD_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/auth/password/reset`,
            method: 'POST',
            body: data
        }),
});

export const getUserContext = () => ({
    types: [
        types.USER_CONTEXT_REQUEST,
        types.USER_CONTEXT_SUCCESS,
        types.USER_CONTEXT_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/auth/context`,
            method: 'GET',
        }),
});

export const setInitialContext = (data) => ({
    type: types.USER_CONTEXT_SUCCESS,
    ...data,
});
